module.exports = __webpack_public_path__ + "img/linkGuidance.a88c5e6e.png";